const DEFAULT_PAYMENT = 7;
const PAYMENT_CASH = 1;
const PAYMENT_INVOICE = 10;

// creditcard, paypal, (unzer direct bank transfer -> currently problems on unzer side), google pay, apple pay, wero
const ONLINE_PAYMENT_TYPES = [7, 9, /*13,*/ 17, 16, 18];

const GERMANY = 82;

const CUSTOMER_PRIVATE_ID = 1;
const CUSTOMER_COMPANY_ID = 2;
const OFFICE_PHONE = '+49 170 3722220';

// Time-gated booking rules, all evaluated on the Munich clock (common/utils/serverClock.js):
// booked at/after LATE_BOOKING_HOUR ->
//   express surcharge for a trip tomorrow (a trip today always pays it; is-transfer-late.js)
//   no online payment link for a trip today or tomorrow (checkShortTermBooking.js)
const LATE_BOOKING_HOUR = 12;
// phone-only banner: booked at/after FROM for a trip before TO tomorrow (OrderActions.jsx)
const LATE_MINUTE_HOUR = {
    FROM: 19,
    TO: 11,
};

const EXTERNAL_LINKS = {
    de: {
        terms: 'https://www.airportliner.com/agb/',
        policy: 'https://www.airportliner.com/datenschutzerklaerung/',
    },
    en: {
        terms: 'https://www.airportliner.com/en/terms-of-conditions/',
        policy: 'https://www.airportliner.com/en/privacy/',
    },
};

const GERMAN_TIMEZONE = 'Europe/Berlin';

// TODO move other extra services to this constant
const SERVICES = {
    LATE_TO_MUNICH: 'LATE_BOOKING_TO_MUNICH',
    LATE_FROM_MUNICH: 'LATE_BOOKING_FROM_MUNICH',
    LATE: 'LATE_BOOKING',
    CHSEAT0: 'CHSEAT0',
    EXTRA_LEGROOM: 'EXTRA_LEGROOM',
};

const DISABLED_SERVICES = {
    [SERVICES.CHSEAT0]: 'extras-info.CHSEAT0',
};

const CUSTOMER_TYPE_PRIVATE = 1;
const CUSTOMER_TYPE_COMPANY = 2;

export {
    DEFAULT_PAYMENT,
    PAYMENT_CASH,
    PAYMENT_INVOICE,
    GERMANY,
    CUSTOMER_PRIVATE_ID,
    CUSTOMER_COMPANY_ID,
    OFFICE_PHONE,
    LATE_BOOKING_HOUR,
    LATE_MINUTE_HOUR,
    GERMAN_TIMEZONE,
    SERVICES,
    ONLINE_PAYMENT_TYPES,
    DISABLED_SERVICES,
    CUSTOMER_TYPE_PRIVATE,
    CUSTOMER_TYPE_COMPANY,
    EXTERNAL_LINKS,
};
